import { render, staticRenderFns } from "./loadingIcon.vue?vue&type=template&id=3fa22398&scoped=true"
var script = {}
import style0 from "./loadingIcon.vue?vue&type=style&index=0&id=3fa22398&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa22398",
  null
  
)

export default component.exports